/**
 * Shared body renderer for the provider/payer columns in ruleset tables.
 * Renders a styled "Default" label for default rules (which have no provider
 * or payer), and the regular name otherwise.
 */
export function defaultScopeCell(row: { isDefault?: boolean }, value?: string) {
  if (row.isDefault) {
    return (
      <span
        style={{
          color: "#6b7280",
          fontStyle: "italic",
          fontWeight: 600,
        }}
      >
        Default
      </span>
    );
  }
  return value ?? "";
}
